<div class="header">
  <h3>Notes and History</h3>
  <button type="button" mat-button (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<credential-history
  [histories]="histories"
  [showScenarioName]="false"
></credential-history>
